import WarningBeforeAction from "e.sic-platform.webclient/src/components/data-components/WarningBeforeAction";
import { observer } from "mobx-react-lite";
import { FormikHelpers, FormikValues } from "formik";
import { UserProfileEditInput } from "e.sic-platform.webclient/src/api-models/request/UserInput";
import { useCallback, useState } from "react";
import { CurrentUserProfileStorageModel } from "e.sic-platform.webclient/src/services/user/CurrentUserProfileStorage";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import Form from "e.sic-platform.webclient/src/components/form/Form";
import AddressFieldsForm from "e.sic-platform.webclient/src/components/form-fields/AddressFieldsForm";
import useErrorHandler, { ApplicationError } from "e.sic-platform.webclient/src/services/error-handler/ErrorHandlerService";

export interface CheckoutModalProps {
    confirmationPending: boolean;
    setConfirmationPending(pending: boolean): void;
    onConfirm(): void;
}

export default observer(function CheckoutModal(props: CheckoutModalProps) {
    const {confirmationPending, setConfirmationPending, onConfirm} = props;
    const { handleErrorInSnackbar } = useErrorHandler();

    const [currentUserProfileStorage] = useState(
        CurrentUserProfileStorageModel.create({}, {api})
    );

    const updateUserProfileDetails = useCallback(async (values: FormikValues, formActions: FormikHelpers<FormikValues>) => {
        try {
            const user: UserProfileEditInput = {
                firstName: values.firstName,
                userName: values.userName,
                lastName: values.lastName,
                email: values.email,
                phone: values.phone || null,
                address: values.address,
                addressNumber: values.addressNumber,
                city: values.city,
                country: values.country,
                state: values.state,
                vat: values.vat,
                zip: values.zip
            };
            await currentUserProfileStorage.editMyUserProfileDetails(user);
            onConfirm();
        } catch (error) {
            const applicationError = error as ApplicationError;
            applicationError.withForm(values, formActions as any);
            applicationError.withErrorMessage("default-error.edit");
            handleErrorInSnackbar(applicationError);
        }
    }, [currentUserProfileStorage, onConfirm]);

    return (
        <Form
            readonly
            formikOptions={{
                initialValues: currentUserProfileStorage.currentUser,
                onSubmit: updateUserProfileDetails,
                validateOnBlur: false,
                validateOnChange: false,
            }}
            onCancel={() => {}}
        >
            {({ values, setFieldValue, submitForm }) => (
                <WarningBeforeAction
                    titleKey="shop.confirm-title"
                    isVisible={confirmationPending}
                    toggleModal={() => setConfirmationPending(!confirmationPending)}
                    buttonOk={{
                        textKey: "shop.buy",
                        action: submitForm
                    }}
                >
                    <AddressFieldsForm values={{...values}} setFieldValue={setFieldValue} edit={true}/>
                </WarningBeforeAction>
            )}
        </Form>
    )
})